<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { useEmployeeRoleStore } from '@/stores/employee-role-store'
import { LicenseType } from '@/types/company'
import { useAuthStore } from '@/stores/auth-store'

import MyButton from '@/components/my-components/MyButton.vue'
import MySelect from '@/components/my-components/form/MySelect.vue'
import ManageAppRolesModal from '@/components/settings/ManageAppRolesModal.vue'

export interface Props {
    tooltip?: string
}

const props = defineProps<Props>()
const roleId = defineModel<string | null>({ required: true })

const { t } = useI18n()
const authStore = useAuthStore()
const roleStore = useEmployeeRoleStore()

const manageAppRolesModalOpen = ref(false)

const showAppRoleField = computed(() => {
    const licensesForRedirectTour =
        authStore.hasLicense(LicenseType.DeliveryManagementModule) &&
        authStore.hasLicense(LicenseType.DriverReportModule)

    return (
        authStore.hasLicense([
            LicenseType.PackagingModule,
            LicenseType.DamageReportModule,
            LicenseType.PODModule,
        ]) || licensesForRedirectTour
    )
})

onMounted(() => {
    if (showAppRoleField.value) {
        roleStore.fetchAppRoles()
    }
})
</script>

<template>
    <div v-if="showAppRoleField" class="flex items-end space-x-2 relative">
        <MySelect
            v-model="roleId"
            :options="roleStore.appRoleOptions"
            :placeholder="t('standard')"
            group-class="w-full"
            name="roleId"
            :label="t('userRole')"
            clear-button
            :loading="roleStore.fetchingAppRoles"
        >
            <template #label>
                <div class="flex items-center">
                    {{ t('userRole') }}
                    <mdi:information
                        v-if="props.tooltip"
                        v-tooltip="props.tooltip"
                        class="ml-1.5 mb-0.5"
                    />
                </div>
            </template>
        </MySelect>

        <MyButton
            v-tooltip="t('manageUserRoles')"
            icon
            type="button"
            @click="manageAppRolesModalOpen = true"
        >
            <mdi:account-group />
        </MyButton>
    </div>
    <ManageAppRolesModal v-model="manageAppRolesModalOpen" />
</template>
